document.addEventListener("DOMContentLoaded", () => {
    initStickyImage();
});

export const initStickyImage = function () {
    const sections = document.querySelectorAll('.section-text2');
    if (!sections.length) return;

    sections.forEach(section => {
        const leftColumn = section.querySelector('.section-text2__left');
        const imageWrapper = section.querySelector('.image1');

        if (!leftColumn || !imageWrapper) return;

        function handleScroll() {
            const containerHeight = leftColumn.offsetHeight;
            const imgHeight = imageWrapper.offsetHeight;

            if (containerHeight <= imgHeight) {
                imageWrapper.classList.remove('glue', 'end');
                imageWrapper.style.width = '';
                imageWrapper.style.bottom = '';
                return;
            }

            const containerRect = leftColumn.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            imageWrapper.style.width = `${containerRect.width}px`;

            const startTrigger = viewportHeight - 40 - imgHeight;
            const endTrigger = viewportHeight - 40;

            if (containerRect.top > startTrigger) {
                imageWrapper.classList.remove('glue', 'end');
                imageWrapper.style.bottom = '';
            } else if (containerRect.top <= startTrigger && containerRect.bottom >= endTrigger) {
                imageWrapper.classList.add('glue');
                imageWrapper.classList.remove('end');
                imageWrapper.style.bottom = '40px';
            } else if (containerRect.bottom < endTrigger) {
                imageWrapper.classList.remove('glue');
                imageWrapper.classList.add('end');
                imageWrapper.style.bottom = '0';
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll, { passive: true });

        handleScroll();
    });
};